export { default } from "./palette.mjs";
export * from "./palette.mjs";